import { Tooltip } from "antd";
import type { ModuleSidebarPage } from "./ModuleSidebar";

/** Един пункт в страничното меню; свито — само иконата, етикетът е в tooltip. */
const ModuleSidebarLink = ({
  page,
  active,
  collapsed,
  onClick,
}: {
  page: ModuleSidebarPage;
  active: boolean;
  collapsed: boolean;
  onClick: () => void;
}) => {
  const { Icon, label } = page;
  const button = (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      className={`relative mb-0.5 flex w-full cursor-pointer items-center gap-2.5 rounded-[7px] border-none text-left text-[12.5px] transition-colors duration-[120ms] ${
        collapsed ? "justify-center py-[9px]" : "justify-start px-2.5 py-2"
      } ${
        active
          ? "bg-surface font-semibold text-ink shadow-[0_1px_2px_rgba(17,17,17,0.04),0_0_0_1px_rgba(17,17,17,0.05)]"
          : "bg-transparent font-medium text-body hover:bg-shade-1"
      }`}
    >
      {active && !collapsed && (
        <span className="absolute -left-3 top-[7px] bottom-[7px] w-[3px] rounded-r-[3px] bg-brand" />
      )}
      <Icon className="text-[14px]" />
      {!collapsed && <span className="truncate">{label}</span>}
    </button>
  );
  if (!collapsed) return button;
  return (
    <Tooltip title={label} placement="right">
      {button}
    </Tooltip>
  );
};

export default ModuleSidebarLink;
